import { GridColDef } from "@mui/x-data-grid";
import { displayDateFormart } from "../utility/utils";

const BidOverviewColumns: GridColDef[] = [
  {
    field: "sbg",
    type: "string",
    width: 80,
    headerName: "SBG",
  },
  {
    field: "sbu",
    type: "string",
    width: 80,
    headerName: "SBU",
  },
  {
    field: "segment",
    type: "string",
    width: 80,
    headerName: "Segment",
  },
  {
    field: "projectName",
    type: "string",
    width: 150,
    headerName: "Project Name",
  },
  {
    field: "customer",
    type: "string",
    width: 120,
    headerName: "Customer Name",
  },
  {
    field: "estimatedValue",
    type: "number",
    width: 150,
    headerName: "Value (INR Cr)",
  },
  {
    field: "contractType",
    type: "string",
    width: 150,
    headerName: "Contract Type",
  },
  {
    field: "bidSubmissionDate",
    type: "string",
    width: 150,
    headerName: "Bid Submission Date",
    valueGetter: ({ value }: any) => {
      return value && new Date(value);
    },
    valueFormatter: ({ value }: any) => {
      return value && displayDateFormart(value);
    },
  },
  {
    field: "projectStatus",
    type: "string",
    width: 150,
    headerName: "Go-NoGo Status",
  },
  {
    field: "goGetFactor",
    type: "string",
    width: 150,
    headerName: "GoGet Factor",
    valueFormatter: ({ value }: any) => {
      return value && Math.round(value);
    },
  },
  {
    field: "workStarted",
    type: "string",
    width: 150,
    headerName: "T&E Status",
  },
  {
    field: "bidManagerName",
    type: "string",
    width: 150,
    headerName: "Bid Manager Name",
  },
  {
    field: "state",
    type: "string",
    width: 150,
    headerName: "State",
  },
  {
    field: "country",
    type: "string",
    width: 150,
    headerName: "Country",
  },
];

export default BidOverviewColumns;
